<template>
  <!-- <el-tooltip class="item" effect="dark" content="筛选" placement="top">
    <div class="pad-right10">
      <el-switch
        class="elswitch"
        v-model="valueseith"
        active-text=""
        @change="screenchange($event)"
      >
      </el-switch>
    </div>
  </el-tooltip> -->
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      style="background: #f6f7fb"
      :content="showSearch == 1 ? '显示搜索' : '隐藏搜索'"
      placement="top"
    >
      <div
        @click="toggleSearch()"
        class="cursorpointer margin-top10 margin-right10"
      >
        <img
          src="@/assets/barsvg/icon／12ycss.png"
          style="position: relative; top: 2px"
          alt=""
        />
        <span class="f12 pad-left5" style="color: #969eac">隐藏搜索</span>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      valueseith: true,
      showSearch: 2,
      num: 1,
    };
  },
  methods: {
    toggleSearch() {
      if (this.num++ % 2 == 0) {
        BUS.$emit("serchkey", true);
        this.showSearch = 2;
      } else {
        BUS.$emit("serchkey", false);
        this.showSearch = 1;
      }
    },
  },
};
</script>
<style scoped>
.el-button {
  border: none !important;
}
.el-button i {
  font-size: 30px !important;
}
</style>